module.exports = __webpack_public_path__ + "img/流体力学5_3.e12f6c5e.jpg";